import React, { useEffect, useState } from "react";
import { AppSidebar, AppHeader } from "@/components/index";
import { useNavigate } from "react-router-dom";
import { auth } from "@/libs/routes";
import { useSelector } from "react-redux";
import { loggedUser } from "@/store/features/userSlice";

/**
 * DefaultLayout is a wrapper component that provides a sidebar, a header, and the content area for the page.
 * It uses React hooks to manage the sidebar's visibility state and renders the children (page content) in the body.
 *
 * @param {object} props - The component props.
 * @param {React.ReactNode} children - The page content that will be rendered inside the layout.
 * @param {Array} breadCrumbArray - The breadcrumb array for navigation.
 *
 * @returns {React.ReactNode} The rendered layout, including the sidebar, header, and content body.
 */
const DefaultLayout = ({ children, breadCrumbArray }) => {
  // State to control the visibility of the sidebar.
  const [sidebarShow, setSidebarShow] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const checkLoggenInUser = useSelector(loggedUser); // Check if the user is logged in using Redux state

  // Check if the user is logged in, if true, redirect to the dashboard
  useEffect(() => {
    // Wait for persist rehydration
    if (checkLoggenInUser) {
      setIsLoading(false);
      
      if (!checkLoggenInUser?.isLoggedIn) {
        navigate(auth.signIn);
      }
    }
  }, [checkLoggenInUser, navigate]);
  
  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      {/* AppSidebar is a sidebar component that accepts visibility and toggle function as props */}
      <AppSidebar sidebarShow={sidebarShow} setSidebarShow={setSidebarShow} />

      <div className="wrapper d-flex flex-column min-vh-100">
        {/* AppHeader is the header component with the sidebar toggle function */}
        <AppHeader
          setSidebarShow={setSidebarShow}
          breadCrumbArray={breadCrumbArray}
          sidebarShow={sidebarShow}
        />

        {/* Main body content */}
        <div className="body flex-grow-1 p-2 container-fluid">
          {/* This renders the child components passed into the layout */}
          {children}
        </div>
      </div>
    </div>
  );
};

export default DefaultLayout;
